import { Form } from 'react-bootstrap';

import { hasInvertedDateRange, type DateRange } from './incidentListParams';

export type { DateRange };

type DateRangeFilterProps = DateRange & {
  onChange: (range: DateRange) => void;
};

const INVERTED_RANGE_MESSAGE = 'End day is before the start day';

const dayOrNull = (value: string): string | null => (value === '' ? null : value);

function DateRangeFilter({ dateStart, dateEnd, onChange }: DateRangeFilterProps) {
  const inverted = hasInvertedDateRange({ dateStart, dateEnd });

  return (
    <div className="diagnostics-date-range">
      <Form.Group controlId="diagnostics-date-start" className="diagnostics-date-field">
        <Form.Label className="visually-hidden">Detected from</Form.Label>
        <Form.Control
          type="date"
          size="sm"
          value={dateStart ?? ''}
          isInvalid={inverted}
          aria-invalid={inverted || undefined}
          onChange={(event) => onChange({ dateStart: dayOrNull(event.target.value), dateEnd })}
        />
      </Form.Group>
      <span aria-hidden="true">→</span>
      <Form.Group controlId="diagnostics-date-end" className="diagnostics-date-field">
        <Form.Label className="visually-hidden">Detected to</Form.Label>
        <Form.Control
          type="date"
          size="sm"
          value={dateEnd ?? ''}
          isInvalid={inverted}
          aria-invalid={inverted || undefined}
          onChange={(event) => onChange({ dateStart, dateEnd: dayOrNull(event.target.value) })}
        />
        <Form.Control.Feedback type="invalid" tooltip>
          {INVERTED_RANGE_MESSAGE}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
}

export default DateRangeFilter;
